/**
 * Theme entry point.
 *
 * Assembles palette, typography, shape, shadows and MUI component
 * overrides into a single MUI theme. This is the only object components
 * are allowed to read design tokens from.
 */
import { createTheme } from '@mui/material/styles';

import { componentOverrides } from './components';
import { paletteOptions } from './palette';
import { elevations } from './shadows';
import { radii, radius, shapeOptions } from './shape';
import { typographyOptions } from './typography';

export const theme = createTheme({
  palette: paletteOptions,
  typography: typographyOptions,
  shape: shapeOptions,
  radii,
  radius,
  elevations,
  components: componentOverrides,
});

export type AppTheme = typeof theme;

export { fontFamilies, fontWeights } from './typography';
export { radii, radius } from './shape';
export { elevations } from './shadows';
export { mergeSx } from './sxUtils';
